export default "__VITE_ASSET__9369faa5__"